


























































































import {Component, Emit, Prop, Vue} from "vue-property-decorator";

@Component
export default class AccountInput extends Vue {
    @Prop() public name!: string;
    @Prop() public kana!: string;
    @Prop() public companyName!: string;
    @Prop() public address!: string;
    @Prop() public email!: string;
    @Prop() public emailCc1!: string;
    @Prop() public emailCc2!: string;
    @Prop() public emailCc3!: string;
    @Prop() public postCodeFirst!: string;
    @Prop() public postCodeLatter!: string;
    @Prop() public buildingName!: string;
    @Prop() public departmentName!: string;

    public confirm = false;

    @Emit()
    public inputNameEmit(inputName: string) {
        // console.log(inputName);
    }

    @Emit()
    public inputKanaEmit(inputKana: string) {
        // console.log(inputKana);
    }

    @Emit()
    public inputCompanyNameEmit(inputCompanyName: string) {
        // console.log(inputCompanyName);
    }

    @Emit()
    public inputAddressEmit(inputAddress: string) {
        // console.log(inputAddress);
    }

    @Emit()
    public inputBuildingNameEmit(inputBuildingName: string) {
        // console.log(inputBuildingName);
    }

    @Emit()
    public inputDepartmentNameEmit(inputDepartmentName: string) {
        // console.log(inputDepartmentName);
    }

    @Emit()
    public inputPostCodeFirstEmit(inputPostCodeFirst: string) {
        // console.log(inputPostCodeFirst);
    }

    @Emit()
    public inputPostCodeLatterEmit(inputPostCodeLatter: string) {
        // console.log(inputPostCodeLatter);
    }

    @Emit()
    public inputEmailEmit(inputEmail: string) {
        // console.log(inputEmail);
    }

    @Emit()
    public inputEmailCc1Emit(inputEmailCc1: string) {
        // console.log(inputEmail);
    }

    @Emit()
    public inputEmailCc2Emit(inputEmailCc2: string) {
        // console.log(inputEmail);
    }

    @Emit()
    public inputEmailCc3Emit(inputEmailCc3: string) {
        // console.log(inputEmail);
    }

    private get inputName(): string {
        return this.name;
    }

    /**
     * @param name
     */
    private set inputName(name: string) {
        this.inputNameEmit(name);
    }

    private get inputKana(): string {
        return this.kana;
    }

    /**
     *  @param kana
     */
    private set inputKana(kana: string) {
        this.inputKanaEmit(kana);
    }

    private get inputPostCodeFirst(): string {
        return this.postCodeFirst;
    }

    /**
     * @param postCodeFirst
     */
    private set inputPostCodeFirst(postCodeFirst: string) {
        this.inputPostCodeFirstEmit(postCodeFirst);
    }

    private get inputPostCodeLatter(): string {
        return this.postCodeLatter;
    }

    /**
     * @param postCodeLatter
     */
    private set inputPostCodeLatter(postCodeLatter: string) {
        this.inputPostCodeLatterEmit(postCodeLatter);
    }

    private get inputCompanyName(): string {
        return this.companyName;
    }

    /**
     * @param companyName
     */
    private set inputCompanyName(companyName: string) {
        this.inputCompanyNameEmit(companyName);
    }

    private get inputAddress(): string {
        return this.address;
    }

    /**
     * @param address
     */
    private set inputAddress(address: string) {
        this.inputAddressEmit(address);
    }

    private get inputBuildingName(): string {
        return this.buildingName;
    }

    /**
     * @param buildingName
     */
    private set inputBuildingName(buildingName: string) {
        this.inputBuildingNameEmit(buildingName);
    }

    private get inputDepartmentName(): string {
        return this.departmentName;
    }

    /**
     * @param departmentName
     */
    private set inputDepartmentName(departmentName: string) {
        this.inputDepartmentNameEmit(departmentName);
    }

    private get inputEmail(): string {
        return this.email;
    }

    /**
     * @param email
     */
    private set inputEmail(email: string) {
        this.inputEmailEmit(email);
    }

    private get inputEmailCc1(): string {
        return this.emailCc1;
    }

    /**
     * @param emailCc1
     */
    private set inputEmailCc1(emailCc1: string) {
        this.inputEmailCc1Emit(emailCc1);
    }

    private get inputEmailCc2(): string {
        return this.emailCc2;
    }

    /**
     * @param emailCc2
     */
    private set inputEmailCc2(emailCc2: string) {
        this.inputEmailCc2Emit(emailCc2);
    }

    private get inputEmailCc3(): string {
        return this.emailCc3;
    }


    /**
     * @param emailCc3
     */
    private set inputEmailCc3(emailCc3: string) {
        this.inputEmailCc3Emit(emailCc3);
    }

    goCancelPage() {
        this.$store.dispatch('billingInfo/pushProgress', 'display');
    }

    goConfirmPage() {
        if(!this.validation()) {
            return;
        }
        this.$store.dispatch('billingInfo/pushProgress', 'confirm');
    }

    private validation(){
        if (this.name === '') {
            alert('請求担当者名を入力してください。');
            return false;
        }
        if (this.kana === '') {
            alert('請求担当者名のカタカナを入力してください。');
            return false;
        }
        if (this.companyName === '') {
            alert('会社名を入力してください。');
            return false;
        }
        if (this.address === '') {
            alert('住所を入力してください。');
            return false;
        }
        if(this.postCodeFirst.match(/[^0-9]+/)){
            alert('郵便番号は半角数字で入力してください。');
            return false;
        }
        if(this.postCodeLatter.match(/[^0-9]+/)){
            alert('郵便番号は半角数字で入力してください。');
            return false;
        }
        if (this.postCodeFirst === '' || this.postCodeFirst.length !== 3) {
            alert('郵便番号は7桁になるよう入力してください。');
            return false;
        }
        if (this.postCodeLatter === '' || this.postCodeLatter.length !== 4) {
            alert('郵便番号は7桁になるよう入力してください。');
            return false;
        }
        return true;
    }
}
